import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  FiPhone,
  FiMail,
  FiMenu,
  FiX,
  FiChevronDown,
  FiChevronRight,
  FiGrid,
} from "react-icons/fi";
import "./Navbar.css";
import logo from "../images/logo.png";

const PRODUCTS_MENU = [
  {
    label: "All Products",
    path: "/all-products",
    hasSub: false,
    highlight: true,
  },
  {
    label: "Uniforms",
    path: "/uniforms",
    hasSub: true,
    sub: [
      { label: "Judo Gi", path: "/uniforms/judo-gi" },
      { label: "Jiujitsu Gi", path: "/uniforms/jiujitsu-gi" },
    ],
  },
  {
    label: "Belts",
    path: '/products/belts',
    hasSub: false,
  },
  { label: "MMA Shorts", path: "/products/mma-shorts", hasSub: false },
  { label: 'Rash Guards', path: '/products/rash-guards', hasSub: false },
  { label: "Spats", path: "/products/spats", hasSub: false },
  { label: "Sports Bra", path: "/products/sports-bra", hasSub: false },
  { label: "Sports Hoodies", path: "/products/sports-hoodies", hasSub: false },
  { label: "Separate Patches", path: "/products/patches", hasSub: false },
];

const DEPT_MENU = [
  { label: "Design Studio", path: "/departments#design" },
  { label: "Pattern Making", path: "/departments#pattern" },
  { label: "Fabric Making", path: "/departments#fabric" },
  { label: "Knitting", path: "/departments#knitting" },
  { label: "Fabric Dyeing", path: "/departments#dyeing" },
  { label: "Printing", path: "/departments#printing" },
  { label: "Cutting", path: "/departments#cutting" },
  { label: "Stitching", path: "/departments#stitching" },
  { label: "Inspection & QC", path: "/departments#inspection" },
  { label: "Packing & Export", path: "/departments#packing" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [prodOpen, setProdOpen] = useState(false);
  const [deptOpen, setDeptOpen] = useState(false);
  const [hoveredSub, setHoveredSub] = useState(null);
  const [mobileExp, setMobileExp] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const prodRef = useRef(null);
  const deptRef = useRef(null);
  const closeTimer = useRef(null);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    setProdOpen(false);
    setDeptOpen(false);
    setMobileOpen(false);
    setHoveredSub(null);
  }, [location]);

  useEffect(() => {
    const fn = (e) => {
      if (prodRef.current && !prodRef.current.contains(e.target))
        setProdOpen(false);
      if (deptRef.current && !deptRef.current.contains(e.target))
        setDeptOpen(false);
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  const handleProdEnter = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setProdOpen(true);
  };
  const handleProdLeave = () => {
    closeTimer.current = setTimeout(() => {
      setProdOpen(false);
      setHoveredSub(null);
    }, 150);
  };
  const toggleMobileAcc = (key) =>
    setMobileExp((p) => ({ ...p, [key]: !p[key] }));

  return (
    <>
      <div className="topbar">
        <div className="container topbar__inner">
          <div className="topbar__right">
            <a href="tel:+923420757213" className="topbar__link">
              <FiPhone size={13} /> +92-342-075 7213
            </a>
            <a
              href="mailto:ShaheenInternationalSports1@gmail.com"
              className="topbar__link"
            >
              <FiMail size={13} /> ShaheenInternationalSports1@gmail.com
            </a>
          </div>
        </div>
      </div>

      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
        <div className="container navbar__inner">
          <Link to="/" className="navbar__logo">
            <img src={logo} alt="Shaheen Sports Logo" className="navbar__logo-img" />
            <div className="logo__text">
              <span className="logo__name">Shaheen Sports</span>
              <span className="logo__tagline">
                Premium Martial Arts Manufacturer
              </span>
            </div>
          </Link>

          <ul className="navbar__links">
            <li>
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  isActive ? "nav-link nav-link--active" : "nav-link"
                }
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive ? "nav-link nav-link--active" : "nav-link"
                }
              >
                About
              </NavLink>
            </li>

            <li
              className="nav-dropdown-wrapper"
              ref={prodRef}
              onMouseEnter={handleProdEnter}
              onMouseLeave={handleProdLeave}
            >
              <button
                className={`nav-link nav-btn ${prodOpen ? "nav-link--active" : ""}`}
                onClick={() => setProdOpen((o) => !o)}
              >
                Products
                <FiChevronDown
                  size={14}
                  className={`chevron ${prodOpen ? "chevron--up" : ""}`}
                />
              </button>
              <div
                className={`prod-dropdown ${prodOpen ? "prod-dropdown--open" : ""}`}
              >
                <div className="prod-dropdown__inner">
                  <div className="prod-dropdown__col--main">
                    {PRODUCTS_MENU.map((item, idx) => (
                      <div key={item.label}>
                        {item.hasSub ? (
                          <div
                            className={`prod-item prod-item--parent ${hoveredSub === idx ? "prod-item--hovered" : ""}`}
                            onMouseEnter={() => setHoveredSub(idx)}
                          >
                            <span
                              className="prod-item__label"
                              onClick={() => {
                                navigate(item.path);
                                setProdOpen(false);
                                setHoveredSub(null);
                              }}
                            >
                              {item.label}
                            </span>
                            <FiChevronRight
                              size={13}
                              className="prod-item__arrow"
                            />
                          </div>
                        ) : (
                          <Link
                            to={item.path}
                            className={`prod-item prod-item--direct ${item.highlight ? "prod-item--highlight" : ""}`}
                            onClick={() => {
                              setProdOpen(false);
                              setHoveredSub(null);
                            }}
                          >
                            {item.highlight && <FiGrid size={13} />}
                            {item.label}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="prod-dropdown__col--sub">
                    {PRODUCTS_MENU.map(
                      (item, idx) =>
                        item.hasSub &&
                        hoveredSub === idx && (
                          <div key={item.label} className="prod-sub-panel">
                            <p className="prod-sub-panel__heading">
                              {item.label}
                            </p>
                            {item.sub.map((s) => (
                              <Link
                                key={s.label}
                                to={s.path}
                                className="prod-sub-link"
                                onClick={() => {
                                  setProdOpen(false);
                                  setHoveredSub(null);
                                }}
                              >
                                <FiChevronRight size={12} /> {s.label}
                              </Link>
                            ))}
                            <Link
                              to={item.path}
                              className="prod-sub-all"
                              onClick={() => {
                                setProdOpen(false);
                                setHoveredSub(null);
                              }}
                            >
                              View All {item.label} →
                            </Link>
                          </div>
                        ),
                    )}
                    {(hoveredSub === null ||
                      !PRODUCTS_MENU[hoveredSub]?.hasSub) && (
                      <div className="prod-sub-placeholder">
                        <p>
                          Hover <strong>Uniforms</strong> or{" "}
                          <strong>Belts</strong>
                          <br />
                          to see sub-types
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </li>

            <li
              className="nav-dropdown-wrapper"
              ref={deptRef}
              onMouseEnter={() => setDeptOpen(true)}
              onMouseLeave={() => setDeptOpen(false)}
            >
              <button
                className={`nav-link nav-btn ${deptOpen ? "nav-link--active" : ""}`}
                onClick={() => setDeptOpen((o) => !o)}
              >
                Departments
                <FiChevronDown
                  size={14}
                  className={`chevron ${deptOpen ? "chevron--up" : ""}`}
                />
              </button>
              <div
                className={`simple-dropdown ${deptOpen ? "simple-dropdown--open" : ""}`}
              >
                {DEPT_MENU.map((d) => (
                  <Link
                    key={d.label}
                    to={d.path}
                    className="simple-dropdown__link"
                    onClick={() => setDeptOpen(false)}
                  >
                    <FiChevronRight size={11} /> {d.label}
                  </Link>
                ))}
              </div>
            </li>

            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  isActive ? "nav-link nav-link--active" : "nav-link"
                }
              >
                Contact
              </NavLink>
            </li>
          </ul>

          <Link to="/contact" className="navbar__cta btn-primary">
            Get a Quote
          </Link>

          <button
            className="navbar__hamburger"
            onClick={() => setMobileOpen((o) => !o)}
            aria-label="menu"
          >
            {mobileOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        <div className={`mobile-menu ${mobileOpen ? "mobile-menu--open" : ""}`}>
          <ul className="mobile-menu__list">
            <li>
              <Link to="/" className="mobile-link">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="mobile-link">
                About Us
              </Link>
            </li>
            <li>
              <button
                className="mobile-link mobile-link--btn"
                onClick={() => toggleMobileAcc("products")}
              >
                Products
                <FiChevronDown
                  size={14}
                  className={`chevron ${mobileExp.products ? "chevron--up" : ""}`}
                />
              </button>
              {mobileExp.products && (
                <div className="mobile-acc">
                  <Link
                    to="/all-products"
                    className="mobile-acc__direct mobile-acc__direct--all"
                  >
                    <FiGrid size={14} /> All Products
                  </Link>
                  {PRODUCTS_MENU.filter((i) => i.label !== "All Products").map(
                    (item) => (
                      <div key={item.label}>
                        {item.hasSub ? (
                          <>
                            <button
                              className="mobile-acc__parent"
                              onClick={() => toggleMobileAcc(item.label)}
                            >
                              {item.label}
                              <FiChevronDown
                                size={12}
                                className={`chevron ${mobileExp[item.label] ? "chevron--up" : ""}`}
                              />
                            </button>
                            {mobileExp[item.label] && (
                              <div className="mobile-acc__sub">
                                <Link
                                  to={item.path}
                                  className="mobile-acc__link mobile-acc__link--all"
                                >
                                  View All {item.label}
                                </Link>
                                {item.sub.map((s) => (
                                  <Link
                                    key={s.label}
                                    to={s.path}
                                    className="mobile-acc__link"
                                  >
                                    <FiChevronRight size={11} /> {s.label}
                                  </Link>
                                ))}
                              </div>
                            )}
                          </>
                        ) : (
                          <Link to={item.path} className="mobile-acc__direct">
                            {item.label}
                          </Link>
                        )}
                      </div>
                    ),
                  )}
                </div>
              )}
            </li>
            <li>
              <button
                className="mobile-link mobile-link--btn"
                onClick={() => toggleMobileAcc("depts")}
              >
                Departments
                <FiChevronDown
                  size={14}
                  className={`chevron ${mobileExp.depts ? "chevron--up" : ""}`}
                />
              </button>
              {mobileExp.depts && (
                <div className="mobile-acc">
                  {DEPT_MENU.map((d) => (
                    <Link
                      key={d.label}
                      to={d.path}
                      className="mobile-acc__direct"
                    >
                      {d.label}
                    </Link>
                  ))}
                </div>
              )}
            </li>
            <li>
              <Link to="/contact" className="mobile-link">
                Contact
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="btn-primary"
                style={{
                  margin: "1rem 1.5rem",
                  display: "block",
                  textAlign: "center",
                }}
              >
                Get a Quote
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}
